var Strings;
(function(Strings) {
Strings['ERROR_MSG_NO_CHILDREN'] = 'has no element children.';
Strings['ERROR_PREFIX'] = 'Menubar constructor argument el ';
})(Strings || (Strings = {}));
export {Strings};
